import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from '@/components/sections/HeroSection';
import VideoDestaqueSection from '@/components/sections/VideoDestaqueSection';
import ContactSection from '@/components/sections/ContactSection';
import ServicesSection from '@/components/sections/ServicesSection';
import ArtistsMarquee from '@/components/sections/ArtistsMarquee';
import PortfolioSection from '@/components/sections/PortfolioSection';
import TestimonialsSection from '@/components/sections/TestimonialsSection';
import TrabalheConosco from '@/components/sections/TrabalheConosco';

export const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        document.getElementById(location.hash.replace('#', ''))?.scrollIntoView({ behavior: 'smooth' });
      }, 500);
    }
  }, [location.hash]);

  return (
    <>
      <HeroSection />
      <VideoDestaqueSection />
      <ContactSection />
      <ServicesSection />
      <ArtistsMarquee />
      <PortfolioSection />
      <TestimonialsSection />
      <TrabalheConosco />
    </>
  );
};

export const TrabalheConoscoPage = () => {
  useEffect(() => { document.title = 'Trabalhe Conosco | Grupo Tomaselli'; }, []);
  return <TrabalheConosco />;
};

export const OrcamentoPage = () => {
  useEffect(() => {
    document.title = 'Solicite seu Orçamento | Grupo Tomaselli';
    window.scrollTo(0, 0);
  }, []);
  return <ContactSection />;
};
